//import './servizi-modals.scss'

import { useAppContext } from '@hooks/use-app-context.ts'
import { Actions } from '@store/reducer.ts'
import { Button } from '@ui/components/button'
import { Title } from '@ui/components/title'
import React from 'react'
import { useModal } from '@hooks/use-modal.ts'

const ErrorModal: React.FC = () => {
	const { dispatch } = useAppContext()
	const { close } = useModal()

	const closeModal = (updateInsurance?: boolean) => {
		close()

		if (updateInsurance) {
			dispatch({ type: Actions.UpdateInsurance, payload: false })
			dispatch({ type: Actions.UpdateAppError, payload: false })
		}
	}

	return (
		<div className='servizi-modal'>
			<div className='servizi-modal__head'>
				<img src='assets/images/esclamativo.png' width={80} />
			</div>
			<Title>
				Ci dispiace, non è possibile procedere alla sottoscrizione della polizza
			</Title>
			<p>
				Ci dispiace, non è possibile procedere alla sottoscrizione della
				polizza. In base alle risposte fornite al questionario, la polizza
				assicurativa non risulta coerente con le tue richieste ed esigenze.
				Quindi, in conformità con quanto previsto dalla normativa di
				riferimento, non è possibile procedere con la sottoscrizione del
				contratto assicurativo.{' '}
			</p>
			<p>
				Premi il tasto indietro se vuoi tornare alla pagina precedente o clicca
				su procedi per procedere con la richiesta di finanziamento senza
				polizza.
			</p>
			<p>
				In questo caso verranno ripristinate le scelte effettuate nel preventivo
				iniziale{' '}
			</p>
			<div className='servizi-modal__footer'>
				<Button
					label='Indietro'
					className='servizi-modal__btn'
					onClick={() => closeModal()}
				/>
				<Button
					label='Procedi senza polizza'
					className='servizi-modal__btn'
					onClick={() => closeModal(true)}
				/>
			</div>
		</div>
	)
}

export default ErrorModal
